/**
 * @generated SignedSource<<9b1bab6d5baf5734521dcd82df1bc183>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Author_authorArticles$data = {
  readonly nodes: ReadonlyArray<{
    readonly rowId: string;
    readonly title: string;
  } | null>;
  readonly " $fragmentType": "Author_authorArticles";
};
export type Author_authorArticles$key = {
  readonly " $data"?: Author_authorArticles$data;
  readonly " $fragmentSpreads": FragmentRefs<"Author_authorArticles">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Author_authorArticles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArticlesConnection",
  "abstractKey": null
};

(node as any).hash = "fa84ac12170c8990424576a82213d159";

export default node;
